document.addEventListener('DOMContentLoaded', () => {
    try {
        CookieConsent.run({
            guiOptions: {
                consentModal: {
                    layout: "bar inline",
                    position: "bottom",
                    equalWeightButtons: true,
                    flipButtons: false
                },
                preferencesModal: {
                    layout: "box",
                    position: "right",
                    equalWeightButtons: true,
                    flipButtons: false
                }
            },
            categories: {
                necessary: {
                    readOnly: true
                },
                analytics: {}
            },
            language: {
                default: "de",
                autoDetect: "browser",
                translations: {
                    de: {
                        "consentModal": {
                            "title": "",
                            "description": "Wir verwenden Cookies, um Ihnen ein optimales Einkauferlebnis bieten zu können, Anzeigen zu personalisieren & Funktionen für soziale Medien bereitzustellen. Weitere Cookies verwenden wir, um anonymisierte Statistiken anfertigen zu können. Wenn Sie auf „Alle akzeptieren“ klicken stimmen Sie der Verwendung von Cookies auf unserer Seite zu. Unter „Einstellungen verwalten“ können Sie die Privatsphäre-Einstellungen jederzeit individuell festlegen oder auch später widerrufen. Weitere Informationen zur Verwendung Ihrer Daten finden Sie in unserer <a href=\"/pages/privatspare_datenschutz\">Datenschutzerklärung</a>.",
                            "acceptAllBtn": "Alle akzeptieren",
                            "acceptNecessaryBtn": "Alle ablehnen",
                            "showPreferencesBtn": "Einstellungen verwalten",
                            "footer": ""
                        },
                        "preferencesModal": {
                            "title": "Einwilligungen",
                            "acceptAllBtn": "Alle akzeptieren",
                            "acceptNecessaryBtn": "Alle ablehnen",
                            "savePreferencesBtn": "Einstellungen speichern",
                            "closeIconLabel": "Modal schließen",
                            "serviceCounterLabel": "Dienste",
                            "sections": [
                                {
                                    "title": "Verwendung von Cookies",
                                    "description": "Wir verwenden Cookies, um Ihnen ein optimales Einkauferlebnis bieten zu können, Anzeigen zu personalisieren & Funktionen für soziale Medien bereitzustellen. Weitere Cookies verwenden wir, um anonymisierte Statistiken anfertigen zu können. Wenn Sie auf „Alle akzeptieren“ klicken stimmen Sie der Verwendung von Cookies auf unserer Seite zu. Unter „Einstellungen verwalten“ können Sie die Privatsphäre-Einstellungen jederzeit individuell festlegen oder auch später widerrufen. Weitere Informationen zur Verwendung Ihrer Daten finden Sie in unserer <a href=\"/pages/privatspare_datenschutz\">Datenschutzerklärung</a>."
                                },
                                {
                                    "title": "Unbedingt notwendige Cookies <span class=\"pm__badge\">Immer aktiviert</span>",
                                    "description": "Technisch notwendige Cookie zum Betrieb der Website.",
                                    "linkedCategory": "necessary"
                                },
                                {
                                    "title": "Analyse-Cookies",
                                    "description": "Marketing- und Analyse-Cookies helfen uns, unsere Website und Dienstleistungen besser auf Sie abzustimmen. Durch die Erfassung von Informationen über Ihre Interaktionen auf unserer Website ermöglichen uns diese Cookies, relevante Werbeinhalte auf Ihre Interessen zuzuschneiden und die Effektivität unserer Marketingkampagnen zu messen. Analyse-Cookies sammeln Daten darüber, wie Sie unsere Website nutzen – beispielsweise welche Seiten Sie am häufigsten besuchen und ob Sie Fehlermeldungen von Webseiten erhalten. Diese Informationen nutzen wir, um die Benutzererfahrung auf unserer Website zu verbessern und sicherzustellen, dass die Website einwandfrei funktioniert. Alle durch diese Cookies gesammelten Informationen sind aggregiert und daher anonym. Wenn Sie diese Cookies nicht zulassen, wird Ihnen weniger zielgerichtete Werbung angezeigt und wir können nicht so effektiv lernen, wie wir unsere Website für Sie verbessern können.",
                                    "linkedCategory": "analytics"
                                }
                            ]
                        }
                    }
                }
            }
        });
    } catch (error) {
        console.error("cookieconsent-config.js: Error running CookieConsent:", error);
    }
});
